import * as TYPES from '../types';

const initialState = {
    collaborationList: [],
};

export function CollaborationReducer(state = initialState, action) {
    const preState = { ...state };
    const { type, payload } = action;
    switch (type) {
        case TYPES.GET_ALL_COLLABORATION_SUCCESS:
            return {
                ...preState,
                collaborationList: payload,
            };

        default:
            return state;
    }
}